// Code review - In Progress
// Documentation - In Progress
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import Loader from "../ReusableComponents/Loader";
import FileUpload from "../ReusableComponents/FileUpload";
import toast from "react-hot-toast";
import { IUDAPI } from "../services/APIConnection";
import download from "../image/download.png";
import pdf from "../image/pdf.png";
import word from "../image/word_icon.png";
import excel from "../image/xls_icon.png";
import ppt from "../image/ppt_icon.png";
import GridPage from "../components/GridPage";
import { popupUserHeader } from "../components/HeaderAttribute";
import GridPageWithCheckBox from "../components/GridPageWithCheckBox";

const ClientPopup = forwardRef(
  (
    {
      data,
      data1,
      isLoading,
      flag,
      popupImage,
      setpopUpOpen,
      onDataChange,
      popupUser,
      selectedUsers,
      selectedUsersClear,
      selectedUsersClearflase,
    },
    ref
  ) => {
    const [proformaInvoice, setProformaInvoice] = useState(false);
    const [proformaInvoiceActive, setProformaInvoiceActive] = useState(false);
    const [taxInvoiceActive, setTaxInvoiceActive] = useState(false);
    const [taxInvoice, setTaxInvoice] = useState(false);
    const [showImage, setShowImage] = useState("");
    //  const [invoiceAmount, setInvoiceAmount] = useState(0);
    const [invoiceAmount, setInvoiceAmount] = useState(data?.Amount || "");
    const [partnerId, setClientsId] = useState(null);
    const [fileClear, setFileClear] = useState(false);
    const [showFileModal, setShowFileModal] = useState(false);
    const [selectedFileUrl, setSelectedFileUrl] = useState("");
    const [isLoadings, setIsLoadings] = useState(false);

    const [selectedRows, setSelectedRows] = useState([]);
    const prevDataRef = useRef({});
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [numberofUsersProvided, setNumberofUsersProvided] = useState("");

    const createdBy = sessionStorage.getItem("createdBy");
    const [showImageError, setShowImageError] = useState("");
    const isProformaAvailable = popupImage?.some(
      (item) => item.ProformaInvoice
    );
    //  const prevDataRef = useRef({});

    useEffect(() => {

      setSelectedRows([])
      const today = new Date();
      const formattedFrom = today.toISOString().split("T")[0];
      setFromDate(formattedFrom);

      const noOfUsers = data?.NoofUsersRequired || "";
      setNumberofUsersProvided(noOfUsers);

      const months = parseInt(data?.SubscriptionPeriodMonths || 0, 10);
      if (months > 0) {
        const toDateObj = new Date(today);
        toDateObj.setMonth(toDateObj.getMonth() + months);
        const formattedTo = toDateObj.toISOString().split("T")[0];
        setToDate(formattedTo);
      } else {
        setToDate("");
      }
    }, [data?.SubscriptionPeriodMonths, data?.NoofUsersRequired]);

    // ✅ Runs once on initial render
    useEffect(() => {
      const today = new Date();
      const formattedFrom = today.toISOString().split("T")[0];

      const noOfUsers = data?.NoofUsersRequired || "";
      const months = parseInt(data?.SubscriptionPeriodMonths || 0, 10);
      let formattedTo = "";
      if (months > 0) {
        const toDateObj = new Date(today);
        toDateObj.setMonth(toDateObj.getMonth() + months);
        formattedTo = toDateObj.toISOString().split("T")[0];
      }

      const initialData = {
        fromDate: formattedFrom,
        toDate: formattedTo,
        numberofUsersProvided: noOfUsers,
      };

      if (typeof onDataChange === "function") {
        onDataChange(initialData);
        prevDataRef.current = initialData;
      }
    }, [data]);

    // ✅ Runs when values change
    useEffect(() => {
      const currentData = {
        fromDate,
        toDate,
        numberofUsersProvided,
      };

      const prevData = prevDataRef.current;

      const hasChanged =
        currentData.fromDate !== prevData.fromDate ||
        currentData.toDate !== prevData.toDate ||
        currentData.numberofUsersProvided !== prevData.numberofUsersProvided;

      if (hasChanged && typeof onDataChange === "function") {
        onDataChange(currentData);
        prevDataRef.current = currentData;
      }
    }, [fromDate, toDate, numberofUsersProvided, onDataChange]);

    const isImageFile = (url) => {
      const imageExtensions = [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "bmp",
        "webp",
        "svg",
      ];
      const ext = url?.split(".").pop()?.toLowerCase();
      return imageExtensions.includes(ext);
    };
    const getViewerUrl = (url) => {
      if (!url) return "";
      const extension = url.split(".").pop().toLowerCase();
      return extension === "pdf"
        ? url
        : `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
          url
        )}`;
    };
    const getFileIcon = (url) => {
      const ext = url?.split(".").pop()?.toLowerCase();
      switch (ext) {
        case "pdf":
          return pdf;
        case "doc":
        case "docx":
          return word;
        case "xls":
        case "xlsx":
          return excel;
        case "ppt":
        case "pptx":
          return ppt; // ✅ return PowerPoint icon
        default:
          return isImageFile(url) ? url : download;
      }
    };
    useEffect(() => {
      if (data && data.MstClientId !== undefined) {
        setClientsId(data.MstClientId);
      }
    }, [data.MstClientId]);

    const handleShowImage = (showImage) => {
      setShowImage(showImage ? showImage : "");

      setShowImageError("");
    };
    useImperativeHandle(ref, () => ({
      childFunction() {
        handleSubmit(0, 1);
      },
      childCancelFunction() {
        cancel();
      },
    }));
    const handleSubmit = async (items, flag) => {
      debugger;
      setIsLoadings(true);
      setShowImageError("");

      if (!showImage) {
        setShowImageError("Please select files to upload");
        setIsLoadings(false);
        return;
      }

      const apiPath = taxInvoice
        ? "ClientsAPI/IUDTaxInvoice"
        : "ClientsAPI/IUDProformaInvoice";

      const partnerPayload = {
        mstClientId: partnerId.toString(),
        url: showImage,
        InvoiceAmount: invoiceAmount,
        SubscriptionPeriodFrom:fromDate,
        SubscriptionPeriodTo:toDate,
        createdby: createdBy,
        flag: taxInvoice ? 2 : 1
      };

      try {
        const response = await IUDAPI(partnerPayload, apiPath);

        const resultTable = taxInvoice
          ? response.data.MainDB
          : response.data.Table1;
        const result = resultTable?.[0]?.Result;

        if (result === "S") {
          toast.success(
            `${taxInvoice ? "Tax" : "Proforma"
            } Invoice Uploaded Successfully 👍`,
            { duration: 3000, position: "top-center" }
          );
        } else {
          toast.error(
            `Failed to Upload ${taxInvoice ? "Tax" : "Proforma"} Invoice 👎`,
            { duration: 3000, position: "top-center" }
          );
        }
      } catch (error) {
        toast.error("Something went wrong while uploading invoice ❌", {
          duration: 3000,
          position: "top-center",
        });
        console.error("Upload error:", error);
      } finally {
        setIsLoadings(false);
        cancel();
      }
    };

    const cancel = () => {
      setProformaInvoice(false);
      setTaxInvoice(false);
      setShowImage(false);
      setFileClear(true);
      setProformaInvoiceActive(false);
      setTaxInvoiceActive(false);
      // ✅ Close the popup
      setpopUpOpen?.(false);
    };
    const clear = () => {
      setProformaInvoice(false);
      setShowImage(false);
      setFileClear(true);
      setProformaInvoiceActive(false);
      setTaxInvoiceActive(false);
    };
    const clear1 = () => {
      setTaxInvoice(false);
      setShowImage(false);
      setFileClear(true);
      setProformaInvoiceActive(false);
      setTaxInvoiceActive(false);
    };
    const handleUploadStatus = (success, message) => {
      if (success) {
        toast.success(message + " 👍", {
          duration: 3000,
          position: "top-center",
        });
      } else {
        toast.error(message + " 👎", {
          duration: 3000,
          position: "top-center",
        });
      }
    };

    const handle1 = (value) => {

      setSelectedRows(value);
    };

    const handleClearValues = (data) => {

      if (data) {
        selectedUsersClearflase(false);
      }
    };


    useEffect(() => {
      if (selectedRows && selectedRows !== undefined) {
        selectedUsers(selectedRows);
      }
    }, [selectedRows]);
    console.log(selectedRows)


    return (
      <div class="w-full">
        <Loader
          isVisible={isLoadings || isLoading}
          size="h-20 w-20"
          color="border-t-black"
          blur={true}
        />
        {flag == 7 || flag == 8 ? (
          <>
            <div class="my-1 max-lg:mt-4 mx-2 lg:mx-4">

              <GridPageWithCheckBox
                header={popupUserHeader}
                records={popupUser}
                rowsPerPageView={true}
                blockView={true}
                addView={true}
                checkBoxVisible={true}
                checkBoxHeaderVisible={true}
                checkBoxStatus={handle1}
                isMultiSelect={true}
                selectedRows={selectedRows ?? []}
                tableHeight="h-60 overflow-y-auto"
                // onAmenitiesDatas={handleAmenitiesData}
                onSpaceDataClear={selectedUsersClear}
                onSpaceDataClearFalse={handleClearValues}
              />
            </div>
          </>
        ) : (
          <div class={mainTable.mainContentScreen}>
            <form class="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit  sm:max-h-fit">
              <div class={mainTable.labelBold}>{`${data.Type == "C" ? "Company" : "Clients"
                } Details`}</div>
              <hr class={mainTable.horizontalLine}></hr>
              <div class="grid gap-4 mb-6 md:grid-cols-3">
                <div>
                  <AutoDropDown
                    title="Property Type"
                    options={[]}
                    placeholder="Select"
                    name="state"
                    selectedOption={[data1[3]]}
                    Class="custom-class"
                    // tabIndex="1"
                    disabled="disabled"
                    classStar="text-red-500"
                  />
                </div>
                <div>
                  <InputText
                    inputType={"text"}
                    title={`Name`}
                    name={" name"}
                    content={data.PropertyName}
                    disabled="disabled"
                    classStar="text-red-500"
                  />
                </div>
                <div>
                  <InputText
                    inputType={"text"}
                    title={`Address`}
                    name={"address"}
                    content={data.Address}
                    disabled="disabled"
                    classStar="text-red-500"
                  />
                </div>
                <div>
                  <AutoDropDown
                    title="Country"
                    options={[]}
                    placeholder="Select"
                    name="state"
                    selectedOption={[data1[0]]}
                    Class="custom-class"
                    // tabIndex="1"
                    disabled="disabled"
                    classStar="text-red-500"
                  />
                </div>
                <div>
                  <AutoDropDown
                    title="State"
                    options={[]}
                    placeholder="Select"
                    name="state"
                    selectedOption={[data1[1]]}
                    Class="custom-class"
                    // tabIndex="1"
                    disabled="disabled"
                    classStar="text-red-500"
                  />
                </div>
                <div>
                  <AutoDropDown
                    title="City"
                    options={[]}
                    placeholder="Select"
                    name="state"
                    selectedOption={[data1[2]]}
                    Class="custom-class"
                    // tabIndex="1"
                    disabled="disabled"
                    classStar="text-red-500"
                  />
                </div>

                <div>
                  <InputText
                    inputType={"number"}
                    title={"Pin Code"}
                    name={"pincode"}
                    content={data.PinCode}
                    disabled="disabled"
                    classStar="text-red-500"
                  />
                </div>

                <div>
                  <InputText
                    inputType={"number"}
                    title={"Number of Users Required"}
                    name={"pincode"}
                    content={data.NoofUsersRequired}
                    disabled="disabled"
                    classStar="text-red-500"
                  />
                </div>
                <div>
                  <InputText
                    inputType={"number"}
                    title={"Number of Users Provided"}
                    name={"pincode"}
                    content={numberofUsersProvided}
                    controlFunc={(e) => setNumberofUsersProvided(e.target.value)}
                    disabled={flag == 5 ? false : true}
                    classStar="text-red-500"
                  />
                </div>
                <div>
                  <InputText
                    inputType="number"
                    title="Subscription Period (Months)"
                    name="subscriptionPeriodMonths"
                    content={data.SubscriptionPeriodMonths}
                    classStar="text-red-500"
                    disabled={true}
                  />
                </div>

                <InputText
                  inputType="date"
                  title="From"
                  name="from"
                  content={fromDate}
                  controlFunc={(e) => {
                    setFromDate(e.target.value);
                  }}
                  classStar="text-red-500"
                />

                <InputText
                  inputType="date"
                  title="To"
                  name="to"
                  content={toDate}
                  controlFunc={(e) => {
                    setToDate(e.target.value);
                  }}
                  classStar="text-red-500"
                />
                <InputText
                  inputType={"text"}
                  title={"GST No. (Put NA if not applicable)"}
                  name={"pincode"}
                  content={data?.GSTNO}
                  disabled="disabled"
                  classStar="text-red-500"
                />
                {/* <InputText
                    inputType={"text"}
                    title={`Invoice Amount`}
                    name={"invoiceAmount"} 
                    content={data?.Amount || 0} 
                    controlFunc={(e) => setInvoiceAmount(e.target.value)}
                     
                    classStar="text-red-500"
                  /> */}
                <InputText
                  inputType="number"
                  title="Invoice Amount"
                  classStar="text-red-500"
                  name="invoiceAmount"
                  content={invoiceAmount}
                  controlFunc={(e) => setInvoiceAmount(e.target.value)}
                />
                {data.Logo && (
                  <div className="flex">
                    <div>
                      <img
                        src={data.Logo}
                        alt="Image"
                        className="rounded-none w-20 h-20"
                      />
                    </div>
                  </div>
                )}
              </div>
              <div class={mainTable.labelBold}>Contact Info</div>
              <hr class={mainTable.horizontalLine}></hr>
              <div class="grid gap-4 mb-6 md:grid-cols-3">
                <div>
                  <InputText
                    inputType={"text"}
                    title={"First Name"}
                    name={"firsName"}
                    content={data.FirstName}
                    disabled="disabled"
                    classStar="text-red-500"
                  />
                </div>
                <div>
                  <InputText
                    inputType={"text"}
                    title={"Last Name"}
                    name={"lastName"}
                    content={data.LastName}
                    disabled="disabled"
                    classStar="text-red-500"
                  />
                </div>
                <div>
                  <AutoDropDown
                    title="Designation"
                    options={[]}
                    placeholder="Select"
                    name="state"
                    selectedOption={[data1[4]]}
                    Class="custom-class"
                    // tabIndex="1"
                    disabled="disabled"
                    classStar="text-red-500"
                  />
                </div>
                <div>
                  <InputText
                    inputType={"text"}
                    title={"Contact Number"}
                    name={"designation"}
                    content={data.ContactNumber}
                    disabled="disabled"
                    classStar="text-red-500"
                  />
                </div>
                <div>
                  <InputText
                    inputType={"text"}
                    title={"Email"}
                    name={"email"}
                    classStar="text-red-500"
                    content={data.Email}
                    disabled="disabled"
                  />
                </div>
                <div class="lg:col-span-3 sm:col-span-1">
                  <div class={mainTable.input_richtextbox}></div>
                </div>
              </div>
              {popupImage?.some((item) => item.ProformaInvoice) && (
                <div className="col-span-3 border p-2 mb-2">
                  {/* Show heading once */}
                  <div className={mainTable.addScreenTitle}>Proforma Invoice</div>

                  {/* List all ProformaInvoice files */}
                  {popupImage.map((item, index) => (
                    <div key={index} className="flex items-center space-x-2 mt-2">
                      <img
                        onClick={() => {
                          setSelectedFileUrl(item.ProformaInvoice);
                          setShowFileModal(true);
                        }}
                        src={getFileIcon(item.ProformaInvoice)}
                        alt={`Proforma Invoice ${index + 1}`}
                        className="w-6 h-6 cursor-pointer"
                      />
                      <span
                        onClick={() => {
                          setSelectedFileUrl(item.ProformaInvoice);
                          setShowFileModal(true);
                        }}
                        className="text-sm text-gray-700"
                      >
                        {(() => {
                          const fullName = decodeURIComponent(
                            item.ProformaInvoice?.split("/").pop() || ""
                          );
                          const lastDotIndex = fullName.lastIndexOf(".");
                          const extension =
                            lastDotIndex !== -1
                              ? fullName.substring(lastDotIndex)
                              : ""; // e.g., .pdf, .docx

                          const nameWithoutExt = fullName.replace(extension, "");
                          const parts = nameWithoutExt.split("_");

                          // Build formatted name: middle part + actual extension
                          const formattedName =
                            parts.length >= 3
                              ? parts.slice(1, -1).join("_") + extension
                              : fullName;

                          return formattedName;
                        })()}
                      </span>
                    </div>
                  ))}
                </div>
              )}
              {popupImage?.some((item) => item.TaxInvoice) && (
                <div className="col-span-3 border p-2 mb-2">
                  {/* Show heading once */}
                  <div className={mainTable.addScreenTitle}>Tax Invoice</div>

                  {/* List all TaxInvoice files */}
                  {popupImage
                    .filter((item) => item.TaxInvoice) // only items with TaxInvoice
                    .map((item, index) => (
                      <div
                        key={index}
                        className="flex items-center space-x-2 mt-2"
                      >
                        <img
                          onClick={() => {
                            setSelectedFileUrl(item.TaxInvoice);
                            setShowFileModal(true);
                          }}
                          src={getFileIcon(item.TaxInvoice)}
                          alt={`Tax Invoice ${index + 1}`}
                          className="w-6 h-6 cursor-pointer"
                        />
                        <span
                          onClick={() => {
                            setSelectedFileUrl(item.TaxInvoice);
                            setShowFileModal(true);
                          }}
                          className="text-sm text-gray-700"
                        >
                          {(() => {
                            const fullName = decodeURIComponent(
                              item.TaxInvoice?.split("/").pop() || ""
                            );
                            const lastDotIndex = fullName.lastIndexOf(".");
                            const extension =
                              lastDotIndex !== -1
                                ? fullName.substring(lastDotIndex)
                                : ""; // e.g., .pdf, .docx

                            const nameWithoutExt = fullName.replace(
                              extension,
                              ""
                            );
                            const parts = nameWithoutExt.split("_");

                            // Build formatted name: middle part + actual extension
                            const formattedName =
                              parts.length >= 3
                                ? parts.slice(1, -1).join("_") + extension
                                : fullName;

                            return formattedName;
                          })()}
                        </span>
                      </div>
                    ))}
                </div>
              )}

              {flag == 6 && (
                <div className={`${mainTable.grid3} gap-4`}>
                  {/* Buttons */}
                  <div className="flex flex-col md:grid md:grid-cols-3  sm:flex-row gap-2 w-full sm:col-span-3">
                    <input
                      type="button"
                      value="Proforma Invoice"
                      id="ProformaInvoice"
                      className={
                        proformaInvoiceActive
                          ? mainTable.disabledSubmitButton
                          : mainTable.submitButton
                      }
                      disabled={proformaInvoiceActive}
                      onClick={() => {
                        setProformaInvoiceActive(false);
                        setTaxInvoiceActive(true);
                        setProformaInvoice(true);
                      }}
                    />

                    <input
                      type="button"
                      value="Tax Invoice"
                      id="TaxInvoice"
                      className={
                        !isProformaAvailable || taxInvoiceActive
                          ? mainTable.disabledSubmitButton
                          : mainTable.submitButton
                      }
                      disabled={!isProformaAvailable || taxInvoiceActive}
                      onClick={() => {
                        setTaxInvoiceActive(false);
                        setProformaInvoiceActive(true);
                        setTaxInvoice(true);
                      }}
                    />
                  </div>

                  {/* Proforma Invoice Upload */}
                  {proformaInvoice && (
                    <div className="w-full sm:col-span-3 border p-3 relative rounded-md shadow">
                      <button
                        type="button"
                        onClick={clear}
                        className="absolute top-2 right-2 text-gray-500 hover:text-black text-lg"
                        title="Close"
                      >
                        ✕
                      </button>
                      <div className={mainTable.addScreenTitle}>
                        Proforma Invoice
                      </div>
                      <div className="flex flex-col gap-4 mt-2">
                        <FileUpload
                          title="Upload Document"
                          name="uploadDocument"
                          classStar="text-red-500"
                          apiCall="ClientsAPI/ProformaInvoiceUpload"
                          modalName="ProformaInvoice"
                          createdBy={createdBy}
                          imageUploadedError={showImageError}
                          mstClientId={partnerId}
                          MAX_FILE_SIZE_MB={2}
                          limitMassage="Attachment file size limit: 2 MB. Accepted file type is PDF only. Please Upload The File After Choosing It."
                          ALLOWED_FORMATS={[
                            // "image/jpeg",
                            // "image/jpg",
                            // "image/png",
                            "application/pdf",
                            // "application/msword",
                            // "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                            // "application/vnd.ms-excel",
                            // "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            // "application/vnd.ms-powerpoint",
                            // "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                          ]}
                          showImageData={handleShowImage}
                          showImage={showImage}
                          imageShow={false}
                          delete={false}
                        />
                      </div>
                    </div>
                  )}

                  {/* Tax Invoice Upload */}
                  {taxInvoice && (
                    <div className="w-full sm:col-span-3 border p-3 relative rounded-md shadow">
                      <button
                        type="button"
                        onClick={clear1}
                        className="absolute top-2 right-2 text-gray-500 hover:text-black text-lg"
                        title="Close"
                      >
                        ✕
                      </button>
                      <div className={mainTable.addScreenTitle}>Tax Invoice</div>
                      <div className="flex flex-col gap-4 mt-2">
                        <FileUpload
                          title="Upload Document"
                          name="uploadDocument"
                          classStar="text-red-500"
                          apiCall="ClientsAPI/TaxInvoiceUpload"
                          modalName="TaxInvoice"
                          createdBy={createdBy}
                          mstClientId={partnerId}
                          imageShow={false}
                          MAX_FILE_SIZE_MB={2}
                          limitMassage="Attachment file size limit: 2 MB. Accepted file type is PDF only. Please Upload The File After Choosing It."
                          ALLOWED_FORMATS={[
                            // "image/jpeg",
                            // "image/jpg",
                            // "image/png",
                            "application/pdf",
                            // "application/msword",
                            // "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                            // "application/vnd.ms-excel",
                            // "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            // "application/vnd.ms-powerpoint",
                            // "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                          ]}
                          imageUploadedError={showImageError}
                          showImageData={handleShowImage}
                          showImage={showImage}
                          delete={false}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </form>
          </div>)}
        {showFileModal && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            onClick={() => setShowFileModal(false)}
          >
            <div
              className="bg-white p-6 rounded shadow-lg max-w-4xl w-full h-full relative"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setShowFileModal(false)}
                className="absolute top-2 right-2 text-gray-500 hover:text-black text-xl"
              >
                ✕
              </button>
              {selectedFileUrl ? (
                isImageFile(selectedFileUrl) ? (
                  <img
                    src={selectedFileUrl}
                    alt="Preview"
                    className="w-full h-full object-contain rounded"
                  />
                ) : (
                  <>
                    <img
                      src={getFileIcon(selectedFileUrl)}
                      alt="File icon"
                      className="w-20 h-20 mx-auto"
                    />
                    <iframe
                      src={getViewerUrl(selectedFileUrl)}
                      title="File Viewer"
                      className="w-full h-[80vh] rounded mt-4"
                    />
                  </>
                )
              ) : (
                <div className="text-center text-gray-500">
                  No file selected
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
);

export default ClientPopup;
